const dimensions = {
  methods: {
    getDimensionById(dimensionId) {
      const dimension = this.dimensions.data.find(o => o.id === dimensionId);
      return dimension || null;
    },

    createDimension(e) {
      e.preventDefault();

      this.$v.validationGroup["dimensions.create_form"].$touch();

      if (this.$v.validationGroup["dimensions.create_form"].$invalid) {
        return;
      }

      this.isLoading = true;

      let requestData = { ...this.dimensions.create_form };

      axios
        .post('dimensions', requestData)
        .then(() => {
          this.dimensions.create_form = {};
          this.$v.validationGroup["dimensions.create_form"].$reset();
        })
        .catch({})
        .finally(() => {
          this.isLoading = false;
          this.fetchInfo();
          this.refreshUser();
        });
    },

    editDimension(dimensionId) {
      const dimension = this.getDimensionById(dimensionId);

      if (dimension) {
        this.dimensions.edit_form[dimensionId] = { ...dimension };
        this.$refs.dimensions_table.toggleChildRow(dimensionId - 0);
      }
    },
    onEditDimensionSubmit(dimensionId) {
      this.$v.validationGroup["dimensions.edit_form"].$each[dimensionId].$touch();

      if (this.$v.validationGroup["dimensions.edit_form"].$each[dimensionId].$invalid) {
        return;
      }

      let vm = this;
      const dimension = this.getDimensionById(dimensionId);

      if (dimension) {
        vm.isLoading = true;
        axios
          .patch(
            '/dimensions/' + dimensionId,
            this.dimensions.edit_form[dimensionId]
          )
          .then(response => {
            vm.$emit('alert', {
              message: response.data.message,
              type: 'success'
            });
            this.$refs.dimensions_table.toggleChildRow(dimensionId - 0);
            this.$v.validationGroup["dimensions.edit_form"].$reset();
          })
          .catch(error => {
            vm.$emit('alert', {
              message: error.response.data.message,
              type: 'danger'
            });
          })
          .finally(() => {
            vm.fetchInfo();
            vm.refreshUser();
          });
      }
    },
    onEditDimensionReset(e) {},

    async deleteDimension(dimensionId) {
      let dialog = null;
      try {
        dialog = await this.$dialog.confirm("Are you sure you want to remove this package dimension?", {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        let vm = this;
        const dimension = this.getDimensionById(dimensionId);

        if (dimension) {
          vm.isLoading = true;
          axios
            .delete(
              '/dimensions/' + dimensionId,
              this.dimensions.edit_form[dimensionId]
            )
            .then(response => {
              vm.$emit('alert', {
                message: response.data.message,
                type: 'success'
              });
            })
            .catch(error => {
              vm.$emit('alert', {
                message: error.response.data.message,
                type: 'danger'
              });
            })
            .finally(() => {
              vm.fetchInfo();
              vm.refreshUser();
            });
        }
      } catch (error) {
        console.error('Deleting a dimension failed', e);
      } finally {
        if(dialog) dialog.close();
      }
    }
  }
};

export default dimensions;



// WEBPACK FOOTER //
// ./resources/assets/js/views/MyAccount/mixins/Dimensions.js